import React from 'react';
import type { FC, ReactNode } from 'react';

interface InitialsCircleProps {
    firstName: string;
    lastName: string;
    className?: string;
}

export const InitialsCircle: FC<InitialsCircleProps> = ({ firstName, lastName, className }) => {
    function map(value: number, start1: number, stop1: number, start2: number, stop2: number) {
        return ((value - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
    }

    const getByteLength = (string: string): number => {
        return new TextEncoder().encode(string[0])[0];
    };

    const minCharByteValue: number = getByteLength('a');
    const maxCharByteValue: number = getByteLength('z');

    const minRange: number = minCharByteValue / maxCharByteValue;
    const maxRange: number = 1;

    const colorByUser = ({
        firstName,
        lastName,
    }: {
        firstName: string;
        lastName: string;
    }): string => {
        if (!firstName && !lastName) {
            return '';
        }

        const userValue = getByteLength(firstName[0]?.toLowerCase()) / getByteLength(lastName[0]?.toLowerCase());

        return `hsl(${map(userValue, minRange, maxRange, 0, 360)}, 50%, 50%)`;
    };

    return (
        <div className={`w-9 h-9 rounded-full col-span-1 ${className}`}>
            <div
                className="w-full h-full mx-auto rounded-full flex place-content-center"
                style={{
                    backgroundColor:
                        firstName || lastName
                            ? colorByUser({
                                  firstName: firstName || '',
                                  lastName: lastName || '',
                              })
                            : 'white',
                }}
            >
                <span className="block text-white my-auto text-sm font-medium">
                    {firstName ? firstName.slice(0, 1) : ''}
                    {lastName ? lastName.slice(0, 1) : ''}
                </span>
            </div>
        </div>
    );
};
